import React from "react";
import { useTranslation } from "react-i18next";
import "../styleSheet/main/languageSwitcher.scss";

const LanguageSwitcher = () => {
  const { i18n } = useTranslation();

  const changeLanguage = (lng) => {
    i18n.changeLanguage(lng);
  };

  // Pokaż tylko przycisk języka, na który można się przełączyć
  const currentLanguage = i18n.language;
  const targetLanguage = currentLanguage === "pl" ? "en" : "pl";
  const targetLabel = targetLanguage.toUpperCase();

  return (
    <div className="language-switcher">
      <button
        className="lang-btn"
        onClick={() => changeLanguage(targetLanguage)}
      >
        {targetLabel}
      </button>
    </div>
  );
};

export default LanguageSwitcher;
